import {
    CALL_API,
    CALL_API_COMPLETE
} from '../../actions'

const initialState = {
    loading: false,
}

const api = (state = initialState, action) => {
    switch (action.type) {
        case CALL_API:
            return {
                ...state,
                loading: true
            }
        case CALL_API_COMPLETE:
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

export default api



// WEBPACK FOOTER //
// ./src/reducers/ui/api.js